import React, { FC } from 'react'
import cn from 'classnames'

const TagDot: FC<{ color?: string }> = ({ color }) => (
  <span
    className={cn('product-tag_dot', { '-empty': !color })}
    style={color ? { backgroundColor: color } : undefined}
  />
)

export default TagDot
